<template>
    <div class="container-fluid">
        <route-header>
            <h3>{{ $t('labels.nav.my_profile') }}</h3>
        </route-header>
        <div class="row mt-3">
            <div class="col-12 col-sm-6 col-lg-4 mb-3">
                <bs-card class="card-info text-center">
                    <img v-if="auth.avatar" :src="'http://localhost:8000/storage/' + auth.avatar" height="180" class="img-circle my-4" />
                    <h4>{{ auth.name }}</h4>
                    <p class="text-uppercase"><small><strong>{{ auth.account }}</strong></small></p>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item text-left">
                            <small class="text-uppercase">{{ $t('labels.role') }}:</small>
                            <span> {{ auth.role }}</span>
                        </li>
                        <li class="list-group-item text-left">
                            <small class="text-uppercase">{{ $t('labels.email') }}:</small>
                            <span> {{ auth.email }}</span>
                        </li>
                    </ul>
                    <template v-slot:footer>
                        <div class="m-3">
                            <bs-button class="btn-sm btn-info" @click="update">{{ $t('labels.update') }}</bs-button>
                        </div>
                    </template>
                </bs-card>
            </div>
            <div class="col-12 col-sm-6 col-lg-8 mb-3">
                <bs-card class="card-info" :label="$t('labels.personal_preferences')" :icon="['fal', 'sliders-h-square']">
                    <div class="form-group p-3">
                        <radio-slider :label="$t('labels.notification_regularity')" :options="notifications" v-model="resource.notification_frequency" @input="submit"></radio-slider>
                    </div>
                </bs-card>
            </div>
        </div>
        <bs-modal :name="'create-Profile'" :label="$t('labels.update_user')">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template v-slot:default="slotProps">
                    <file-field :name="'picture'" :label="$t('labels.profile_picture')" v-model="resource.picture" :error="slotProps.error"></file-field>
                    <input-field :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error"></input-field>
                    <input-field :type="'email'" :name="'email'" :label="$t('labels.email')" v-model="resource.email" :error="slotProps.error"></input-field>
                    <input-field :type="'password'" :name="'password'" :label="$t('labels.password')" :help="$t('messages.password_not_required')" v-model="resource.password" :error="slotProps.error"></input-field>
                </template>
            </bs-form>
        </bs-modal>

    </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Profile',
  data () {
    return {
      resource: {
        picture: '',
        name: '',
        email: '',
        password: '',
        notification_frequency: ''
      },
      notifications: {
        never: this.$t('labels.resource_state.never'),
        instant: this.$t('labels.resource_state.instant'),
        daily: this.$t('labels.resource_state.daily'),
        weekly: this.$t('labels.resource_state.weekly')
      }
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },
  created () {
    this.resource.picture = null
    this.resource.name = this.auth.name
    this.resource.email = this.auth.email
    this.resource.password = null
    this.resource.notification_frequency = this.auth.settings.notification_frequency
  },
  methods: {
    update () {
      this.$store.commit('axiosError', null)
      this.$modal.show('create-Profile')
    },
    submit () {
      this.$store.commit('submitting', true)
      const formData = new FormData()
      for (const key in this.resource) {
        formData.append(key, this.resource[key] ?? '')
      }
      this.$store.dispatch('chunk', {
        url: '/api/profile',
        resource: this.resource,
        icon: ['fal', 'user'],
        message: this.$t('messages.uploading_image'),
        callback: () => { this.$store.dispatch('showUser') }
      }).then(() => {
        this.$modal.hide('create-Profile')
      })
      // chunk.post('/api/profile', this.resource, { headers: { 'Content-Type': 'multipart/form-data' } })
      //   .then(response => {
      //     this.$store.dispatch('showUser')
      //     this.$modal.hide('create-Profile')
      //     this.$store.commit('submitting', false)
      //   })
    }

  }
}
</script>
